import { useQuery } from "@tanstack/react-query";
import {
  CustomValueImportRowsParams,
  CustomValueImportRowsResponse,
  fetchCustomValueImportRows
} from "PFCore/services/admin/imports/fetch_custom_value_import_rows";
import { Id } from "PFTypes";
import { QueryOptions } from "PFTypes/request_options";

import { customValueImportRowsKeys } from "./query_keys";

export const useCustomValuesImportRows = (
  importId: Id,
  params?: CustomValueImportRowsParams,
  options: QueryOptions<CustomValueImportRowsResponse> = {}
) =>
  useQuery<CustomValueImportRowsResponse>(
    customValueImportRowsKeys.import(importId, params),
    () => fetchCustomValueImportRows(importId, params),
    { retry: false, ...options }
  );
